import { apiRequest } from "@services/apiClient";
import cmsPurchasesEndpoints from "@services/cmsPurchases/cmsPurchasesEndpoints";

const emptyPagination = {
  page: 1,
  limit: 20,
  total: 0,
  totalPages: 1,
};

function normalizePagination(pagination) {
  return {
    page: Number(pagination?.page || emptyPagination.page),
    limit: Number(pagination?.limit || emptyPagination.limit),
    total: Number(pagination?.total || emptyPagination.total),
    totalPages: Math.max(1, Number(pagination?.totalPages || emptyPagination.totalPages)),
  };
}

function normalizePurchasesBody(body) {
  return {
    purchases: Array.isArray(body?.purchases) ? body.purchases : [],
    pagination: normalizePagination(body?.pagination),
  };
}

function normalizePurchaseDetailBody(body) {
  return body?.purchase && typeof body.purchase === "object" ? body.purchase : null;
}

export async function listCmsPurchasesRequest(params) {
  const response = await apiRequest(cmsPurchasesEndpoints.list(params));
  return {
    ...response,
    body: normalizePurchasesBody(response?.body),
  };
}

export async function getCmsPurchaseDetailRequest(id) {
  const response = await apiRequest(cmsPurchasesEndpoints.byId(id));
  return {
    ...response,
    body: normalizePurchaseDetailBody(response?.body),
  };
}
